import script from "./AddModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddModal.vue?vue&type=script&setup=true&lang=js"

import "./AddModal.vue?vue&type=style&index=0&id=08814299&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08814299"]])

export default __exports__